import { SearchItem } from '../../../../models/search-item';
import { Aggregate } from '../../../../models/aggregate';
import {
    addFilterItemsFailedAction,
    addFilterItemsStartAction,
    addFilterItemsSucceededAction,
    removeAllFilterItemsSucceededAction,
    removeFilterItemFailedAction,
    removeFilterItemStartedAction,
    removeFilterItemSucceededAction,
    removeFiltersAndKeepLastAggSucceededAction,
    updateFilterItemsFailedAction,
    updateFilterItemsStartAction,
    updateFilterItemsSucceededAction, updateProcessStateFilterSucceedAction
} from '../action/wkf-supervision-filter.action';
import { createReducer, on } from '@ngrx/store';
import * as _ from 'lodash';


export enum ProcessStateEnum {
    OPEN ='open',
    ALL='all',
    closed='closed'
}

export interface WkfSupervisionFilterDatas {
  filterItems: SearchItem[];
  lastAgg: Aggregate;
  processState: ProcessStateEnum;
}
export interface WkfSupervisionFilterState {
  datas: WkfSupervisionFilterDatas;
  loading: boolean;
  error: any;

}

export const WKF_SUPERVISION_FILTER_INITIAL_STATE: WkfSupervisionFilterState = {
  datas: {
    filterItems: [],
    lastAgg: null,
    processState: ProcessStateEnum.OPEN
  },
  loading: false,
  error: null
};


export const wkfSupervisionFilterReducer = createReducer(
  WKF_SUPERVISION_FILTER_INITIAL_STATE,
  on(addFilterItemsStartAction, (state) => { return ({
    ...state,
    loading: true,
    error: null,
  })}),
  on(addFilterItemsSucceededAction, (state, {payload} ) => {
    const add = _.cloneDeep(state.datas);
    const toAdd = payload.filterItems[0];

    if (!toAdd.operator) {
      add.filterItems = add.filterItems.concat(toAdd);
    } else {
      const existingFilterItemRange = add.filterItems.find(
        (existingFilterItem) =>
          existingFilterItem.operator === toAdd.operator &&
          existingFilterItem.path === toAdd.path
      );

      if (!existingFilterItemRange) {
        add.filterItems = add.filterItems.concat(toAdd);
      } else {
        add.filterItems[add.filterItems.indexOf(existingFilterItemRange)] = toAdd;
      }
    }

    add.lastAgg = payload.lastAgg;
    return {
      ...state,
      datas: add,
      loading: false,
      error: null,
    }
  }),
  on(addFilterItemsFailedAction, (state, {error} ) => { return ({
    ...state,
    loading: false,
    error: error,
  })}),
  on(updateFilterItemsStartAction, (state) => { return ({
    ...state,
    loading: true,
    error: null,
  })}),
  on(updateFilterItemsSucceededAction, (state, {payload}) => {
    const toReplace: SearchItem = payload.filterItems[0];
    let found = false;
    let searchItems = state.datas.filterItems.map(aFilterItem => {
      if (aFilterItem.path === toReplace.path && aFilterItem.operator === toReplace.operator) {
        found = true;
        return toReplace;
      } else {
        return aFilterItem;
      }
    });
    if (!found) {
      searchItems = [...searchItems, toReplace];
    }
    return {
      ...state,
      datas: {
        ...state.datas,
        filterItems: searchItems,
        lastAgg: payload.lastAgg
      },
      loading: false,
      error: null,
    }
  }),
  on(updateFilterItemsFailedAction, (state, {error} ) => { return ({
    ...state,
    loading: false,
    error: error,
  })}),
  on(removeFilterItemStartedAction, (state) => { return ({
    ...state,
    loading: true,
    error: null,
  })}),
  on(removeFilterItemSucceededAction, (state, {payload}) => {
    const filterItem: SearchItem = payload.filterItems[0];
    let oldLastAgg = state.datas.lastAgg;
    const oldProcessState = state.datas.processState;
    let remove: SearchItem[];
    if (!filterItem.operator) {
      remove = state.datas.filterItems.filter(item => item.path !== filterItem.path || item.value !== filterItem.value);
    } else {
      remove = state.datas.filterItems.filter(item => item.path !== filterItem.path || item.operator !== filterItem.operator);
    }
    if (remove.length === 0) {
      oldLastAgg = null;
    }
    return {
      ...state,
      datas: {
        filterItems: remove,
        lastAgg: oldLastAgg,
        processState: oldProcessState
      },
      loading: false,
      error: null,
    };
  }),
  on(removeFilterItemFailedAction, (state, {error} ) => { return ({
    ...state,
    loading: false,
    error: error,
  })}),
  on(removeAllFilterItemsSucceededAction, (state) => { return ({
    ...state,
    datas: {
      filterItems: [],
      lastAgg: null,
      processState : ProcessStateEnum.OPEN
    },
    loading: false,
    error: null,
  })}),
  on(removeFiltersAndKeepLastAggSucceededAction, (state) => { return ({
    ...state,
    datas: {
      ...state.datas,
      filterItems: []
    },
    loading: false,
    error: null
  })}),
  on( updateProcessStateFilterSucceedAction , (state , {payload} ) => {
      const datasCopy = _.cloneDeep(state.datas);
      datasCopy.processState = payload
      return ({
          ...state,
          datas:datasCopy,
          loading: false,
          error: null,
      })
  }),
);
